var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"info"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-icon',{staticClass:"ms-2",attrs:{"size":"20","color":"accent"}},[_vm._v("mdi-alert-circle")])],1)]}}])},[_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.$t("Ni har kandidater att hantera")))])])}
var staticRenderFns = []

export { render, staticRenderFns }